import { Component, HostListener, Inject, Input, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { AuthenticationResult, EventMessage, EventType, PopupRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { concatMap, filter, takeUntil } from 'rxjs/operators';
import { Globals } from './models/globals.model';
import { MsalBroadcastService, MsalService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { GlobalService } from './services/global.service';
import { GraphService } from './services/graph.service';
import { HttpService } from './services/http.service';
import { OverageService } from './services/overage.service';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { TenantService } from './services/tenant.service';
import { AppConstants } from './app.constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  isLoading: boolean;
  response: any;
  @Input('ngModel') model: any;
  disableTooltip = false;
  sidenavWidth = 3.5;
  showCross = false;
  isAuthorize: boolean = false;
  isActivate: boolean = true;
  appInsights: ApplicationInsights;
  appInsightKey: any;
  isMenuOpen: boolean = false;

  private readonly _destroying$ = new Subject<void>();

  constructor(private readonly authService: MsalService,
    @Inject(MSAL_GUARD_CONFIG) private readonly msalGuardConfig: MsalGuardConfiguration,
    private readonly msalBroadcastService: MsalBroadcastService,
    private readonly grphService: GraphService,
    private readonly overageService: OverageService,
    public _router: Router, private readonly httpService: HttpService,
    public globals: Globals, public globalService: GlobalService,
    private readonly tenantService: TenantService) {
    this.countryList = [
      {
        "Id": 1,
        "Name": "Dutch",
        "Code": "NL",
      },
      {
        "Id": 2,
        "Name": "English",
        "Code": "EN",
      },
      {
        "Id": 3,
        "Name": "French",
        "Code": "FR",
      },
      {
        "Id": 4,
        "Name": "German",
        "Code": "DE",
      },
    ];
  }


  title = 'Platform';
  countryList: any;
  data: any;
  countryCode: any;
  isMobileResolution: boolean;
  screenWidth: any;

  @HostListener('window:resize', ['$event'])
  getScreenSize() {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth < 768) {
      this.isMobileResolution = true;
    }
    else {
      this.isMobileResolution = false;
    }
  }

  public ngOnInit() {
    this.isLoading = true;
    this.initialize();
    this.countryCode = "EN";

  }

  initialize() {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
        takeUntil(this._destroying$),
        concatMap(async () => this.checkoutAccount())
      ).subscribe()
  }

  login() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
          this.checkoutAccount();
        });
    } else {
      this.authService.loginPopup()
        .subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
        });
    }
  }

  checkoutAccount() {
    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }

    let userAccount = this.authService.instance.getAllAccounts()[0];
    if (userAccount?.name && this.globals.userName == '') {
      this.globals.userName = userAccount.name;
      let idParts = userAccount.name.split(' ');
      if (idParts.length > 1) {
        this.globals.userShortName = idParts[0].charAt(0) + idParts[1].charAt(0);
        this.globalService.loggedInUser = idParts[0] + ' ' + idParts[1];
      }
      else {
        this.globals.userShortName = idParts[0].charAt(0);
        this.globalService.loggedInUser = idParts[0];

      }

      this.globals.userEmail = userAccount.username;

      // call appinsight
      this.initAppInsight(this);
      if (this.globals.groups.length === 0) {
        this.overageService.readGraphGroups(this.authService, this.grphService, this.assignRole, this);
      }
    }
  }

  initAppInsight(thisRef: AppComponent) {
    let appInsightKey = (thisRef.globals.config.appInsightKey) ? thisRef.globals.config.appInsightKey : "test";
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: appInsightKey,
        enableAutoRouteTracking: true
      }
    });
    this.appInsights.loadAppInsights();
    this.setUserId();
    this.logPageView();
  }

  logPageView(name?: string, url?: string, properties?: any, measurements?: any) {
    this.appInsights.trackPageView({
      name: name,
      uri: url,
      properties: properties,
      measurements: measurements
    });
  }
  setUserId() {
    this.appInsights.setAuthenticatedUserContext(this.globals.userEmail);
    this.appInsights.context.user.id = this.globals.userEmail;
  }

  assignRole(thisRef: AppComponent) {
    thisRef.globals.groups.push(thisRef.globals.config.groups_client_FlowsheetBuilderUserGroupId, thisRef.globals.config.groups_client_PlatformAdminGroupId)
    if (thisRef.grphService.user.groupIDs.includes(thisRef.globals.config.groups_client_PlatformAdminGroupId)) {
      thisRef.globals.rbacName = 'Platform Admin';
    }
    else if (thisRef.grphService.user.groupIDs.includes(thisRef.globals.config.groups_client_FlowsheetBuilderUserGroupId)) {
      thisRef.globals.rbacName = 'Flowsheet Builder User';
    }
    else {
      thisRef.globals.rbacName = 'User';
    }

    thisRef.tenantService.getTenantListFromServer(AppConstants.componentId);
    thisRef.isLoading = false;
  }

  // toggle side navigation drawer
  toggleCollapse() {
    if (this.sidenavWidth === 3.5) {
      this.disableTooltip = true;
      this.showCross = true;
      this.sidenavWidth = 15.5;
      this.isMenuOpen = true;
    } else {
      this.disableTooltip = false;
      this.showCross = false;
      this.sidenavWidth = 3.5;
      this.isMenuOpen = false;
    }
  }

  isActive(label): boolean {
    if (this._router.url.includes(label)) {
      return this._router.url.includes(label);
    }
  }

  selectFlag(Code: any) {
    this.countryCode = Code;
  }
}
